import { DeviceSection } from './DeviceSection'
import { withDeviceSection } from './withDeviceSection'

const ConnectedDeviceSection = withDeviceSection(DeviceSection)

export { ConnectedDeviceSection as DeviceSection }
